import axios from 'axios'
import { useEffect, useState } from 'react'
import FileViewer from '../../FileViewer';
import { FaCheck, FaCommentDots } from "react-icons/fa";
import UsersInterestsChatModal from './UsersInterestsChatModal';
const BASE_URL = process.env.REACT_APP_BASE_URL;
const UsersInterest = () => {
  const [interests, setInterests] = useState([])
  const [search, setSearch] = useState("")
  const [isOpen,setIsOpen] = useState(false)
  const [currentItem,setCurrentItem] = useState(null)
  // console.log("The interests are:",interests)
   const fetchInterests = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/marketplace/researcher/interest/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        });

        setInterests(response.data); // ✅ FIXED
      } catch (error) {
        console.log('error while fetch interests', error)
      }
    }
    useEffect(() => {
    fetchInterests()
  }, [])

const HandleOpportunityHired = async (interest_id,hired_to,is_hired) => {
  // console.log("The person which is hired",interest_id,hired_to,is_hired)
  if(!interest_id)
  {
     alert("interest id required")
     return;
  }
   if(!hired_to)
   {
     alert('The user which one hiring you id is required')
     return;
   }
    try {
      const response = await axios.post(`${BASE_URL}/marketplace/researcher/opportunity/hire/`,{
        interest:interest_id,
        hired_to:hired_to,
        is_hired:is_hired
      },{
          headers: {
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            'x-api-key': process.env.REACT_APP_X_API_KEY,
          },
        })
        // console.log("The response is:",response)
      fetchInterests()
    } catch (error) {
       console.log('error while change opportunity hire status', error)
    }
}
  return (
 <div className="p-0 md:p-6 w-full mx-auto">
   {/* Header */}
   <div className="flex items-center gap-3 mb-6">
    <div className="w-12 h-12 bg-[#e8f0f7] rounded-xl flex items-center justify-center">
      <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    </div>
    <div>
      <h1 className="text-lg md:text-2xl font-bold text-gray-900">
  Users Interest
</h1>

<p className="text-sm text-gray-500 mt-1">
  View and manage user interest submissions for opportunities. You can review applications, communicate with candidates, and mark their hiring status.
</p>
    </div>
  </div>
    {/* Search and Add Bar */}
  {
     interests?.length > 0 &&  
      <div className="w-full flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
  {/* Search Input */}
  <div className="relative flex-1 w-full">
    <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </div>
    <input
      type="text"
      placeholder="Search interest by name or email..."
      value={search}
      onChange={(e) => setSearch(e.target.value)}
      className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>
</div>
  }

  <div className="space-y-6">
    {!interests ? (
    // Loader
    <div className="w-full flex justify-center items-center h-32">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-500"></div>
    </div>
  ) : interests.length === 0 ? (
    // No publications
    <div className="w-full text-center text-gray-500 py-10">
        No interests until now
    </div>
  ) : (
    interests?.filter(item =>
  !search ||
  item?.email?.toLowerCase()?.includes(search?.toLowerCase()) ||
  item?.from_user_data?.name?.toLowerCase()?.includes(search?.toLowerCase())
).map((item, index) => (
      <div
        key={index}
        className="border bg-white border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-md transition-all duration-200 hover:border-gray-300"
      >
        {/* TOP ROW */}
        <div className="flex justify-between items-start mb-4">
           
          {/* LEFT SIDE */}
          <div className="space-y-1">
             <div className='flex gap-4'>
               <div className="relative w-10 h-10">
                <img
                  src={item?.from_user_data?.profile_picture}
                  alt={item?.from_user_data?.name}
                  className="w-10 h-10 rounded-xl object-cover border border-gray-200"
                />
                <div className="absolute -bottom-1 -right-1 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
              </div>
               <div>
                <p className="font-semibold text-gray-900">{item?.from_user_data?.name}</p>
                 <p className="font-semibold text-gray-900">{item.email}</p>
               </div>
             </div>
            <div className="flex items-center gap-2 text-gray-600 text-sm">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span>{item.phone}</span>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="flex items-center gap-3">

            {/* STATUS */}
            <span
              className={`text-xs px-3 py-1.5 rounded-full font-medium ${
                item.status === "pending"
                  ? "bg-amber-50 text-amber-700"
                  : item.status === "accepted"
                  ? "bg-green-50 text-green-700"
                  : "bg-red-50 text-red-700"
              }`}
            >
              {item.status}
            </span>

            {/* CHAT ICON */}
            <button
            onClick={()=>{
              setCurrentItem(item)
              setIsOpen(true)
            }}
  className="px-3 py-2 bg-[#0f6abf] whitespace-nowrap text-white text-xs font-medium rounded-lg hover:bg-[#0a5ca8] transition-colors flex items-center gap-1"
>
  {/* Chat Icon */}
  <svg
    className="w-3.5 h-3.5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8 10h.01M12 10h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4-.8L3 20l1.2-3.6A7.962 7.962 0 013 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
    />
  </svg>

  Chat
</button>

            {/* HIRED */}
  

<div className="flex items-center gap-2">
  <span className="text-sm font-medium text-gray-700">Hired</span>

  <div className="flex gap-1">

    {/* YES BUTTON */}
    <button
      disabled={item.hires === true}
      onClick={() => HandleOpportunityHired(item.id, item?.from_user, true)}
      className={`px-3 py-1 text-xs font-medium rounded-lg flex items-center gap-1 transition-colors
        ${item.hires === true
          ? "bg-green-200 text-green-800 cursor-not-allowed"
          : "bg-green-100 text-green-700 hover:bg-green-200"
        }`}
    >
      {item.hires === true && <FaCheck size={12} />}
      Yes
    </button>

    {/* NO BUTTON */}
    <button
      disabled={item.hires === false}
      onClick={() => HandleOpportunityHired(item.id, item?.from_user, false)}
      className={`px-3 py-1 text-xs font-medium rounded-lg flex items-center gap-1 transition-colors
        ${item.hires === false
          ? "bg-red-200 text-red-800 cursor-not-allowed"
          : "bg-red-100 text-red-700 hover:bg-red-200"
        }`}
    >
      {item.hires === false && <FaCheck size={12} />}
      No
    </button>

  </div>
</div>

          </div>
        </div>

        {/* MESSAGE */}
        <div className="mb-4 p-3 bg-gray-50 rounded-xl">
          <p className="text-sm text-gray-700">{item.message}</p>
        </div>

        {/* OPPORTUNITY */}
        <div className="pt-3 border-t border-gray-100">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
            <h3 className="text-sm font-semibold text-gray-900">For this Opportunity</h3>
          </div>
      {/* Opportunity Data */}
              <div
             
              className="bg-white rounded-2xl border border-gray-200 overflow-hidden hover:shadow-md transition-all duration-200 flex flex-col"
            >
      <div className="p-3 border border-gray-200  cursor-pointer transition-all duration-200 hover:shadow-md">

  <div className="flex flex-wrap gap-2">
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {item?.opportunity ? item.opportunity_data?.domain : item.labopportunity_data?.domain}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-50 text-blue-600 border border-blue-100">
      {item?.opportunity ? item.opportunity_data?.collaboration : item.labopportunity_data?.collaboration}
    </span>

    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-gray-50 text-gray-700 border border-gray-200">
      {item?.opportunity ? item.opportunity_data?.maturity : item.labopportunity_data?.maturity}
    </span>
    
    <span className="text-xs font-medium px-3 py-1.5 rounded-lg bg-green-50 text-green-600 border border-green-100">
      {item?.opportunity ? item.opportunity_data?.visibility : item.labopportunity_data?.visibility}
    </span>
  </div>
</div>
              {/* Media Preview */}
               <FileViewer publication_type={item?.opportunity ? item.opportunity_data?.publication_type : item.labopportunity_data?.publication_type} file={item?.opportunity ? item.opportunity_data?.file : item.labopportunity_data?.file} name={item?.opportunity ? item.opportunity_data?.name : item.labopportunity_data?.name} />
              {/* Content */}
              <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
                  <h2 className="text-lg font-semibold text-gray-900">
                    {item?.opportunity ? item.opportunity_data?.name : item.labopportunity_data?.name}
                  </h2>
                </div>
                <p className="text-sm text-gray-600 mt-2 flex-grow">
                  {item?.opportunity ? item.opportunity_data?.summary : item.labopportunity_data?.summary}
                </p>
                {/* Button */}
                {/* <button
                  onClick={() => handleViewDetails(publication.id)}
                  className="mt-6 w-full py-3 bg-[#0f6abf] text-white text-sm font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                  </svg>
                  View Details
                </button> */}
              </div>
            </div>
            {/* End of Opportunity Data */}
        </div>

        <p className="text-xs text-gray-400 mt-4 flex items-center gap-1">
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {new Date(item.created_at).toLocaleString()}
        </p>
      </div>
    )))}
  </div>
  <UsersInterestsChatModal isOpen={isOpen} onClose={()=>setIsOpen(false)} item={currentItem}  />
</div>
  )
}

export default UsersInterest